import { type SelectProps, Select as AntSelect } from 'antd';
import clsx from 'clsx';
import './Select.scss';

const Select = ({ placeholder, ...props }: SelectProps) => {
    return (
        <div className={clsx('flex flex-col space-y-2 w-full')}>
            {placeholder && (
                <label className={clsx(
                    'text-sm font-medium transition-colors duration-300',
                    'text-gray-700 dark:text-gray-300'
                )}>
                    {placeholder}
                </label>
            )}
            <AntSelect
                {...props}
                optionFilterProp='name'
                className={clsx(
                    'w-full transition-all duration-300',
                    'border-gray-300 dark:border-gray-600',
                    'text-gray-900 dark:text-white',
                    'hover:border-blue-400 dark:hover:border-blue-500',
                    'focus:border-blue-500 dark:focus:border-blue-400',
                    'focus:shadow-md focus:shadow-blue-500/20 dark:focus:shadow-blue-500/10',
                    'rounded-lg',
                    // Hover state - matching Input
                    '[&_.ant-select-selector]:hover:!border-blue-400',
                    '[&_.ant-select-selector]:hover:!dark:border-blue-500',
                    // Focus state - matching Input
                    '[&_.ant-select-focused_.ant-select-selector]:!border-blue-500',
                    '[&_.ant-select-focused_.ant-select-selector]:!dark:border-blue-400',
                    '[&_.ant-select-focused_.ant-select-selector]:!shadow-md',
                    '[&_.ant-select-focused_.ant-select-selector]:!shadow-blue-500/20',
                    '[&_.ant-select-focused_.ant-select-selector]:!dark:shadow-blue-500/10',
                    // Placeholder - matching Input
                    '[&_.ant-select-selection-placeholder]:!text-gray-400',
                    '[&_.ant-select-selection-placeholder]:!dark:text-gray-500',
                    // Arrow icon
                    '[&_.ant-select-arrow]:!text-gray-500',
                    '[&_.ant-select-arrow]:!dark:text-gray-400'
                )}
            />
        </div>
    );
};

export { Select };
